/** Mirrors backend `Sestek.AgenticCX.Enums.UiColorTheme`. */
export enum UiColorTheme {
  Signature = 1,
  Vibrant = 2,
  Minimal = 3,
}
